import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Id } from 'Src/types/aliases'
import { PatentModel } from 'Pages/registratorCabinet'
import { Callback } from 'Src/types/utilTypes'

export type CommonPatentsState = {
	patents: PatentModel[]
}

export const commonPatentsInitialState: CommonPatentsState = {
	patents: [],
}

export namespace CommonPatentsNS {
	export type getPatents = PayloadAction<Id>
	export type setPatents = PayloadAction<PatentModel[]>
	export type clearPatents = PayloadAction
	export type createPatent = PayloadAction<{ id: Id; data: PatentModel; callback?: Callback }>
	export type deletePatent = PayloadAction<{ id: Id; patentId: Id }>
	export type updatePatent = PayloadAction<{
		id: Id
		patentId: Id
		data: PatentModel
		callback?: Callback
	}>
}

export const commonPatentsSlice = createSlice({
	name: 'commonPatents',
	initialState: commonPatentsInitialState,
	reducers: {
		getPatents: (state, action: CommonPatentsNS.getPatents) => {},
		setPatents: (state, action: CommonPatentsNS.setPatents) => {
			state.patents = action.payload
		},
		clearPatents: (state, action: CommonPatentsNS.clearPatents) => {
			state.patents = []
		},
		createPatent: (state, action: CommonPatentsNS.createPatent) => {},
		deletePatent: (state, action: CommonPatentsNS.deletePatent) => {},
		updatePatent: (state, action: CommonPatentsNS.updatePatent) => {},
	},
})
